import { Button, Flex } from "antd";
import type React from "react";
import { useAppSelector } from "../../hooks/redux-hooks";
import { closeImpersonationSession, getImpersonationSession } from "../../utils/impersonation.utils";

/**
 * Non-dismissible banner shown on every authenticated page during a GOD mode
 * (admin login-as-user) session. Detection uses both the local flag written by
 * /impersonate and the server-truth `impersonation` field on /users/userinfo/,
 * so the banner survives either one being missing.
 */
const ImpersonationBanner: React.FC = () => {
  const { userInfo } = useAppSelector((state) => state.auth);
  const userData = useAppSelector((state) => state.user.data);
  const localSession = getImpersonationSession();
  const serverSession = userInfo.impersonation;

  if (!localSession && !serverSession?.active) return null;

  const impersonatedEmail = localSession?.email || userData?.email || "";
  const adminEmail = serverSession?.admin_email || localSession?.admin || "";
  const expiresIso = serverSession?.expires_at || localSession?.expires || "";
  const expiresLabel = expiresIso
    ? new Date(expiresIso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })
    : "";

  return (
    <Flex
      align="center"
      justify="center"
      gap={12}
      wrap="wrap"
      style={{
        flex: "0 0 auto",
        padding: "6px 16px",
        background: "repeating-linear-gradient(135deg, #7F1D1D 0px, #7F1D1D 24px, #991B1B 24px, #991B1B 48px)",
        color: "#FFFFFF",
        fontWeight: 600,
        textAlign: "center",
      }}
    >
      <span>
        🔱 GOD MODE — logged in as <u>{impersonatedEmail}</u>
        {adminEmail && ` (by ${adminEmail})`}
        {expiresLabel && ` · expires ${expiresLabel}`}
      </span>
      <Button
        size="small"
        danger
        onClick={() => {
          void closeImpersonationSession();
        }}
        style={{ fontWeight: 600 }}
      >
        Close session
      </Button>
    </Flex>
  );
};

export default ImpersonationBanner;
